import React, { useEffect, useState } from "react";
import "./ProducerFilter.scss";
import { ControlOutlined, SearchOutlined } from "@ant-design/icons";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import largeModeImg from "@assets/icons/large-icons.svg";
import smallModeImg from "@assets/icons/small-icons.svg";
import { ReactComponent as HayIcon } from "@assets/icons/hayIcon.svg";
import { ReactComponent as SeedIcon } from "@assets/icons/seedIcon.svg";
import { ReactComponent as StrawIcon } from "@assets/icons/strawIcon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Input, Select, Button } from "antd";
import { useNavigate } from "react-router-dom";
import Helpers from "@utils/Helpers";
import Suggestion from "@components/Suggestion/Suggestion";
import FilterControl from "@components/FilterControl/FilterControl";
const { Option } = Select;

let debounceTimer: any;

interface IProducerFilter {
  isOpenMap: boolean;
  setIsOpenMap: (isOpen: boolean) => void;
  searchParam: any;
  setSearchParam: (param: any) => void;
  componentIn: string;
  submit?: () => void;
  viewMode: string;
  setViewMode: (mode: string) => void;
}

const ProducerFilter: React.FC<IProducerFilter> = ({
  isOpenMap,
  setIsOpenMap,
  searchParam,
  setSearchParam,
  componentIn,
  submit,
  viewMode,
  setViewMode,
}) => {
  const [seletedCategory, setSelectedCategory] = useState(1);
  const [selectChange, setSelectChange] = useState(false);
  const [searchResult, setSearchResult] = useState<any[]>([]);
  const [isOpenSuggestion, setIsOpenSuggestion] = useState(false);
  const [isFilterControlOpen, setIsFilterControlOpen] = useState(false);
  const navigate = useNavigate();

  const categoryList = [
    {
      id: 1,
      name: "Hay",
      image: <HayIcon className="image" />,
    },
    {
      id: 2,
      name: "Straw",
      image: <StrawIcon className="image" />,
    },
    {
      id: 3,
      name: "Seed",
      image: <SeedIcon className="image" />,
    },
  ];

  const handleSearchInputChange = (key: string, value: any) => {
    setSearchParam({ ...searchParam, [key]: value || "" });
    if (
      key !== "query" &&
      key !== "address" &&
      componentIn === "productCatalog"
    ) {
      setSelectChange(true);
    }
  };

  useEffect(() => {
    if (selectChange) {
      handleSearch();
    }
  }, [selectChange]);

  const handleSearch = () => {
    const encodedParams = encodeURIComponent(JSON.stringify(searchParam));
    navigate(`/search?params=${encodedParams}`);
  };

  const handleClearKeyWord = () => {
    setSearchParam({
      query: "",
      address: "",
      radius: "100",
      type: null,
      location: null,
      selling_method: null,
      quantity: "",
      shape: null,
      filters: {
        hay_cut: [],
        bale_weight_min: 0,
        bale_weight_max: 200,
        shape: [],
        size: [],
        hay_compression: [],
        moisture: [],
        rain: [],
        storage: [],
        crop: [],
        binding_type: [],
        price_min: 0,
        price_max: 1000,
        shipping_options: [],
        payment_options: [],
      },
    });
  };

  return (
    <>
      <div className="ProducerFilter">
        <div className="filter-wrap">
          <div className="sort-group mt-4">
            <Row gutter={[12, 12]}>
              <Col span={6}>
                <div className="category-list">
                  {categoryList.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`category-item ${
                          searchParam.categories_id.includes(item.id) &&
                          item.id !== 3
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => {
                          if (item.id !== 3) {
                            const currentIds = searchParam?.categories_id || [];
                            const isCurrentlyOnlySelected =
                              currentIds.length === 1 &&
                              currentIds.includes(item.id);
                            const updatedCategoryIds = isCurrentlyOnlySelected
                              ? [1, 2]
                              : [item.id];

                            setSearchParam({
                              ...searchParam,
                              categories_id: updatedCategoryIds,
                            });
                          }
                        }}
                      >
                        <div className="d-flex align-items-center category-content">
                          {item.id === 3 && (
                            <div className="watermark">
                              <div className="background"></div>
                              <p className="coming-soon">COMING SOON</p>
                            </div>
                          )}
                          <div className="category-title">
                            <div className="category-image">{item.image}</div>
                            <span
                              className="category-name"
                              style={{
                                marginLeft: item.id === 3 ? "0" : "",
                              }}
                            >
                              {item.name}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Col>
              <Col span={12}>
                <Input
                  size={"large"}
                  variant="filled"
                  placeholder="Search"
                  suffix={
                    <Button
                      icon={<SearchOutlined />}
                      size="small"
                      color="default"
                      variant="filled"
                      className="search-btn"
                      onClick={() => {
                        if (searchParam.query !== "") {
                          handleSearch();
                        }
                      }}
                    />
                  }
                  className="search-input"
                  value={searchParam.query}
                  onChange={(e) =>
                    handleSearchInputChange("query", e.target.value)
                  }
                />
              </Col>
              <Col span={3}>
                <div className="view-mode">
                  <div
                    onClick={() => setViewMode("large")}
                    className={`large-mode ${viewMode === "large" && "mode"}`}
                  >
                    <img src={largeModeImg} alt="large-mode" />
                  </div>
                  <div
                    onClick={() => setViewMode("small")}
                    className={`small-mode ${viewMode === "small" && "mode"}`}
                  >
                    <img src={smallModeImg} alt="small-mode" />
                  </div>
                </div>
              </Col>
              <Col span={3}>
                <Button
                  size={"large"}
                  variant="filled"
                  className={`map-btn ${isOpenMap && "active"}`}
                  icon={<FontAwesomeIcon icon={faMap} />}
                  onClick={() => setIsOpenMap(!isOpenMap)}
                >
                  Map
                </Button>
              </Col>
              <Col span={6}>
                <Button
                  className="open-filter-btn"
                  size="large"
                  color="default"
                  variant="filled"
                  onClick={() => setIsFilterControlOpen(true)}
                  icon={<ControlOutlined />}
                >
                  Filter
                </Button>
              </Col>
              <Col span={6}>
                <div className="map-search-input">
                  <Input
                    size={"large"}
                    variant="filled"
                    placeholder="Location"
                    className="search-input"
                    value={searchParam.address}
                    addonAfter={
                      <Input
                        disabled={
                          searchParam.location === "" || !searchParam.location
                        }
                        value={searchParam.radius}
                        onChange={(e) =>
                          handleSearchInputChange("radius", e.target.value)
                        }
                        className="radius-input"
                        variant="borderless"
                        suffix="km"
                      />
                    }
                    onChange={(e) => {
                      const query = e.target.value;
                      setIsOpenSuggestion(true);
                      if (query === "") {
                        setIsOpenSuggestion(false);
                      }
                      clearTimeout(debounceTimer);
                      debounceTimer = setTimeout(async () => {
                        const result = await Helpers.handleSearchLocation(
                          query
                        );
                        setSearchResult(result);
                      }, 300);
                      handleSearchInputChange("address", e.target.value);
                    }}
                  />
                  {isOpenSuggestion && (
                    <Suggestion
                      searchResult={searchResult}
                      onSelect={(item) => {
                        setIsOpenSuggestion(false);
                        setSearchParam({
                          ...searchParam,
                          address: item.display_name,
                          location: [
                            parseFloat(item.lat),
                            parseFloat(item.lon),
                          ],
                        });
                        if (componentIn === "productCatalog") {
                          setSelectChange(true);
                        }
                      }}
                    />
                  )}
                </div>
              </Col>
              <Col span={6}>
                <Select
                  size={"large"}
                  variant="filled"
                  placeholder="Type"
                  className="search-input"
                  value={searchParam.type}
                  onChange={(value) => handleSearchInputChange("type", value)}
                >
                  <Option value="Alfalfa">Alfalfa</Option>
                  <Option value="Alfalfa mix">Alfalfa mix</Option>
                  <Option value="Brome Grass">Brome Grass</Option>
                  <Option value="Timothy">Timothy</Option>
                  <Option value="Grass mix">Grass mix</Option>
                  <Option value="Orchard Grass">Orchard Grass</Option>
                  <Option value="Clover">Clover</Option>
                  <Option value="Sainfoin">Sainfoin</Option>
                </Select>
              </Col>
              <Col span={3}>
                <Input
                  size={"large"}
                  variant="filled"
                  placeholder="Quantity"
                  className="search-input"
                  value={searchParam.quantity}
                  onChange={(e) =>
                    handleSearchInputChange("quantity", e.target.value)
                  }
                />
              </Col>
              <Col span={3}>
                <Button
                  size={"large"}
                  className="filter-btn"
                  onClick={handleClearKeyWord}
                >
                  Clear All
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <FilterControl
        isOpen={isFilterControlOpen}
        setIsOpen={setIsFilterControlOpen}
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        submit={submit}
        componentIn={componentIn}
      />
    </>
  );
};

export default ProducerFilter;
